import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ConsentRootState } from './consentStore.util';
import type { RootState } from './reemaStore.util';
import { Dispatch } from '@reduxjs/toolkit';

export const useAppDispatch: () => Dispatch<any> = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useConsentAppSelector: TypedUseSelectorHook<ConsentRootState> =
  useSelector;
